import { createContext } from "react";

const BraceletContext = createContext();

export default BraceletContext;